import React from "react";
import PropTypes from "prop-types";
import { detect } from "detect-browser";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBars,
  faTimes,
  faChevronLeft,
} from "@fortawesome/free-solid-svg-icons";
import {
  Wrapper,
  MenuWrapper,
  SubNavWrapper,
  CloseButton,
  Links,
  LinkWrapper,
  LinkItem,
  BetaBadge,
  Title,
} from "./styles/hamburger-menu-styles";
import * as storage from "../../../storage";

const HamburgerMenu = (props) => {
  const {
    burgerMenuActive,
    subNavActive,
    handleBurgerMenu,
    handleSubNav,
    mobileMenuLinks,
    candidatesSubNav,
    cameFromSubNav,
    isEmployer,
  } = props;

  const handleMetricsLink = (e) => {
    e.preventDefault();
    handleBurgerMenu();
    if (isEmployer) {
      window.location.href =
        "/employer/dashboard/#metrics_performance_scroller";
    } else {
      window.location.href =
        "/recruiter/dashboard/#metrics_performance_scroller";
    }
  };

  const handleMessagesLink = (e, label) => {
    storage.local.removeItem("conversations-list-mobile-hidden", "mobile-out");
    storage.local.setItem("conversations-list-mobile-shown", "mobile-in");

    if (label === "Metrics") {
      handleMetricsLink(e);
    }
  };

  const iOS = detect().name === "ios";

  return (
    <Wrapper>
      <MenuWrapper burgerMenuActive={burgerMenuActive}>
        <CloseButton onClick={handleBurgerMenu}>
          <FontAwesomeIcon icon={faTimes} />
        </CloseButton>
        <Links iOS={iOS}>
          {mobileMenuLinks
            .filter((link) => link !== null)
            .map((link) => (
              <LinkWrapper
                key={link.label && link.label}
                href={link.url && link.url}
                onClick={
                  link.subNav
                    ? () => handleSubNav("subnav")
                    : (e) => handleMessagesLink(e, link.label)
                }
              >
                <LinkItem
                  dot={link.notificationDot && link.notificationDot}
                  iOS={iOS}
                >
                  {link.label && link.label}
                  {link.beta && <BetaBadge>beta</BetaBadge>}
                </LinkItem>
              </LinkWrapper>
            ))}
        </Links>
      </MenuWrapper>
      <SubNavWrapper subNavActive={subNavActive}>
        <FontAwesomeIcon
          icon={faChevronLeft}
          onClick={
            cameFromSubNav ? () => handleSubNav("subnav") : () => handleSubNav()
          }
        />
        <Title>Candidates</Title>
        <Links>
          {candidatesSubNav.map((subNavLink) => (
            <LinkWrapper key={subNavLink.label} href={subNavLink.url}>
              <LinkItem>{subNavLink.label}</LinkItem>
            </LinkWrapper>
          ))}
        </Links>
      </SubNavWrapper>
      <FontAwesomeIcon icon={faBars} onClick={handleBurgerMenu} />
    </Wrapper>
  );
};

HamburgerMenu.propTypes = {
  burgerMenuActive: PropTypes.bool.isRequired,
  subNavActive: PropTypes.bool.isRequired,
  handleBurgerMenu: PropTypes.func.isRequired,
  handleSubNav: PropTypes.func.isRequired,
  mobileMenuLinks: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  candidatesSubNav: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  cameFromSubNav: PropTypes.bool,
  isEmployer: PropTypes.bool,
};

HamburgerMenu.defaultProps = {
  cameFromSubNav: PropTypes.isNull,
  isEmployer: PropTypes.isNull,
};

export default HamburgerMenu;
